import { useState } from 'react'
import { Tabs, Tab, Typography } from '@mui/material'
import colors from 'styles/colors'

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  }
}

const SidebarMenu = ({
  tabLabels = [],
  initialActive = 0,
  onTabChange = () => {},
  containerSx = {}
}) => {
  const [value, setValue] = useState(initialActive)
  const handleChange = (event, newValue) => {
    setValue(newValue)
    onTabChange(newValue)
  }

  return (
    <Tabs
      orientation='vertical'
      value={value}
      onChange={handleChange}
      sx={{
        '& .MuiTabs-list': {
          gap: 4
        },
        '& .MuiTabs-indicator': {
          display: 'none'
        },
        ...containerSx
      }}>
      {tabLabels.map((label, index) => (
        <Tab
          key={index}
          sx={{
            width: '100%',
            minHeight: 'auto',
            paddingX: 8,
            paddingY: 4,
            borderRadius: 1,
            backgroundColor: colors.White,
            alignItems: 'flex-start',
            textAlign: 'start',
            overflow: 'unset',
            '&:hover': {
              backgroundColor: colors.Grey50
            },
            '&.Mui-selected': {
              backgroundColor: colors.MutedTeal50
            }
          }}
          label={
            <Typography variant='h4' fontWeight={500}>
              {label}
            </Typography>
          }
          {...a11yProps(index)}
        />
      ))}
    </Tabs>
  )
}

export default SidebarMenu
